// extracted by mini-css-extract-plugin
export default {"container":"Home_container__1+49Z","section2":"Home_section2__oCOW0","section":"Home_section__4V9I-","homeBackground":"Home_homeBackground__8P0sh"};